import React from 'react';
import styles from './favorite-words/FavoriteWordsView.module.css';
import { BookIcon } from '../../components/Icons';

const FavoritePhrasesView = ({ groups, bookMetadata, onOpenBookPhrases }) => {
  if (!groups.length) {
    return (
      <div className={styles.noHistory}>
        <div className={styles.noHistoryIcon}><BookIcon size={48} /></div>
        <h3>还没有收藏的短语</h3>
        <p>在阅读AI笔记时点击短语旁的收藏按钮即可收藏</p>
      </div>
    );
  }

  return (
    <div className={styles.wordsSectionWrapper}>
      {groups.map((bookGroup) => {
        const bookMeta = bookMetadata[String(bookGroup.bookId)] || {};
        const bookTitle = bookMeta.title || bookGroup.bookTitle || '未命名书籍';

        return (
          <button
            key={bookGroup.key}
            type="button"
            className={styles.wordsCard}
            onClick={() => onOpenBookPhrases(bookGroup)}
            aria-label={`查看${bookTitle}的收藏短语`}
          >
            <div className={styles.wordsCardTitle}>{bookTitle}</div>
            <span className={styles.wordsCardCount}>短语 {bookGroup.itemCount}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FavoritePhrasesView;

